<div class="transaction-container">
  @for (t of transactionCategoryList; track t.transaction.id) {
    <app-transaction
      [transactionCategory]="t"
      (alterTransaction)="alterTransaction.emit($event)"
      (deleteTransaction)="deleteTransaction.emit($event)"
    ></app-transaction>
  }
</div>
